import React from 'react';
import styles from './pageNotFound.module.scss';
import { useTranslation } from "react-i18next";
import { ReactComponent as NotFoundIcon } from "@/assets/icons/notFound.svg";
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/route/routes.constants';

export const PageNotFound: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <div className={styles.pageContainer}>
            <div className={styles.logoContainer}><NotFoundIcon /></div>
            <h2 className={styles.text}>{t('page_not_found')}</h2>
            <p className={styles.subText}>
                {t('page_not_found_msg')}
            </p>
            <button className={styles.button} onClick={() => navigate(ROUTES.INSPECTIONS)}>
                {t('back_to_home')}
            </button>
        </div>
    );
}

